import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';

// Components
import Input from '../inputs/input';

//CSS
const chip = { float: "right", paddingLeft: 'auto' }
const item = { display: "flex", justifyContent:"space-between" }


const Dropdown = ({ values, getOptionLabel, getOptionValue, size, ...rest }) =>
    <Input 
        select={values && values.length > 0}
        size={size}
        {...rest}
    >
    {
        values &&
        values.map((option, index) => {
            const label = getOptionLabel(option);
            const value = getOptionValue(option);

            return (
                <MenuItem style={item} key={index} value={value} disabled={option.disabled}>
                    {
                        label
                    } 
                    {
                        !value?.quantity &&
                        <Chip size="small" color="primary" label="Sin Stock" variant="outlined" style={chip} />
                    }
                </MenuItem>
            )
        })
    }
    </Input>

Dropdown.defaultProps = {
    getOptionLabel: (option) => option.label,
    getOptionValue: (option) => option.value
}

Dropdown.prototype = {
    values: PropTypes.array,
    getOptionLabel: PropTypes.func,
    getOptionValue: PropTypes.func
}

export default Dropdown;